module.exports = __webpack_public_path__ + "img/new1.ba16ad9b.png";